

import React from 'react'
import LayoutModal from '../../Layout/Dashboard/LayoutModal'
import FormWorks from './FormWorks'
import { useAddWorks } from '../../api/works'
import { getDataToSend, getInitialValues, getValidationSchema } from './formUtil'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useTranslation } from 'react-i18next'

function AddWorksModal() {


  const [t] = useTranslation()
  const {mutate , status} = useAddWorks()
  const handelSubmit = (values:any )=>{

    const dataToSend = getDataToSend(values)

    mutate(dataToSend)
    // Submit Value
  }
  return (
    <LayoutModal
    
     isAddModal={true}
     getInitialValues={getInitialValues()} 
     handleSubmit={handelSubmit} 
     status={status as QueryStatusEnum}
     headerText={t('Add') +t('works')}
     
     getValidationSchema={getValidationSchema()}>

    <FormWorks />
  </LayoutModal>
  )
}

export default AddWorksModal

